import React, {Fragment, useEffect, useState} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import {MaterialStylusLaserPointerIcon} from "../../../common/svgIcons/materialIcons";
import {getCommonVisualizerType} from "../../../../config";
import {setLookAiWaitingBoxClicked} from "../../aiActions";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import LookIntroCanvasHighlighting from "../../../look/lookNavigation/lookIntro/lookIntroCanvasHighlighting";
import LookCanvasContext from "../../../look/lookCanvasContext";

let showTimeoutId = null;


const LookAIWaitingBox = (props) => {

  const {intl, fabricatorData, aiLoading, aiResults, lookAiWaitingBoxClicked, setLookOverlayOpened, isMobile,
    setLookAiWaitingBoxClicked} = props;

  const [showWaitingBox, setShowWaitingBox] = useState(false);

  useEffect(() => {
    if (aiLoading && !lookAiWaitingBoxClicked) {
      clearTimeout(showTimeoutId);
      showTimeoutId = setTimeout(() => {
        setShowWaitingBox(true);
      }, 1500)
    } else if (lookAiWaitingBoxClicked && showWaitingBox) {
      clearTimeout(showTimeoutId);
      setShowWaitingBox(false);
    }
    return () => {
      clearTimeout(showTimeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aiLoading, lookAiWaitingBoxClicked]);

  if (aiResults.some(aiResult => aiResult.conversionError || aiResult.resultImageUrl)) {
    return null
  }

  const continueDesigningClick = () => {
    setLookAiWaitingBoxClicked(true);
    setLookOverlayOpened("");
  }

  const visualizerType = getCommonVisualizerType();

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <Fragment>
          <div style={{ left: isMobile ? "23.5rem" : 0 }}
               className={"fixed transition2 look-ai__overlay u-top-1 u-right-1 u-bottom-1"
            + (!showWaitingBox ? " opacity-0 visibility-hidden" : "")}>
            <div
              className={"look-intro__box look-icon--with-shadow " + (!showWaitingBox ? " look-intro__box--hidden" : "")
                + (isMobile ? " u-w-full" : "")}>
              <div className="grohe-lead__box-icon">
                {MaterialStylusLaserPointerIcon}
              </div>
              <div className="">
                <h2 className="look-intro__box-title bold">
                  <FormattedMessage id="look.ai.waitingBox.title"/>
                </h2>
                <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                            className="look-icon look-icon--white2 look-icon--small absolute u-right-05 u-top-05 look-icon--gray8 rounded-full"
                            onClick={continueDesigningClick}>
                  <CloseIcon/>
                </IconButton>
                <p className="look-intro__box-text">
                  <FormattedMessage id="look.ai.waitingBox.text" values={{
                    visualizerType: intl.formatMessage({id: "rooms." + visualizerType}),
                  }}/>
                </p>
                <div className="look-intro__box-buttons">
                  <Button className={"look-button look-button--160 look-button--no-transform look-button--no-padding "
                    + (fabricatorData.isAmericanStandard ? "look-button--primary2" : "look-button--blue")}
                          onClick={continueDesigningClick}>
                    <FormattedMessage id="look.ai.waitingBox.button"/>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {showWaitingBox ? <LookIntroCanvasHighlighting imageCanvas={imageCanvas} isWaitingBox={true}/> : null}
        </Fragment>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {aiLoading, aiResults, lookAiWaitingBoxClicked} = store.aiState;
  const fabricatorData = store.fabricatorState;

  return {
    isMobile,
    fabricatorData,
    aiLoading,
    aiResults,
    lookAiWaitingBoxClicked,
  };
};

const mapDispatchToProps = {
  setLookAiWaitingBoxClicked,
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIWaitingBox)
)
